import React from 'react';
import Social from './extras/Social';

const Banner = () => {
	return (
		<header className='banner' id='banner'>
			<video className='banner__video' poster='/img/banner.png' autoPlay loop muted>
				<source src='/img/banner.mp4' type='video/mp4' />
			</video>

			<div className='banner__container'>
				<div className='banner__contenido'>
					<div className='banner__contenido-logo'>
						<img src='./img/logo.svg' alt='logo corso cnc' width='150' />
					</div>
					<div className='banner__contenido-texto'>
						<h1 className='banner__title'>DISEÑO, DESARROLLO Y FABRICACIÓN DE MESAS DE CORTE CNC</h1>

						<div className='banner__wsapp'>
							<img src='./img/wapp.svg' alt='icon whatsapp' width='25' />
							<span className='banner__wsapp-number'>320 937 7591</span>
						</div>
					</div>
					<div className='banner__contenido-contacto'>
						<Social />
						<p className='banner__call'>Contáctanos!</p>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Banner;
